var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 =
    _vm.nowPageIndex == 1
      ? _vm.__map(_vm.treeData, function (item, __i0__) {
          var $orig = _vm.__get_orig(item)
          var g0 = _vm.vk.pubfn.isNotNull(item.children)
          return {
            $orig: $orig,
            g0: g0,
          }
        })
      : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event, item) {
      var _temp = arguments[arguments.length - 1].currentTarget.dataset,
        _temp2 = _temp.eventParams || _temp["event-params"],
        item = _temp2.item
      var _temp, _temp2
      $event.stopPropagation()
      _vm.checkMoreDetail(item, _vm.vk.pubfn.isNotNull(item.children))
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }